import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "line1",
  "use": "line1-usage",
  "viewBox": "0 0 68 4",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 68 4\" fill=\"none\" id=\"line1\"><path id=\"line1_矩形 7\" fill-rule=\"evenodd\" style=\"fill:#1D7045\" transform=\"translate(0 0)  rotate(0 34 2)\" opacity=\"1\" d=\"M0,4L68,4L68,0L0,0L0,4Z \" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/line1.svg
// module id = UQy8
// module chunks = 21